export default function useResize() {
  function resize(width?: number, height?: number) {
    const camera = useCamera()
    const renderer = useRenderer()
    const sizes = useSizes()

    sizes.resize(width, height)
    camera.resize()
    renderer.resize()
  }

  return {
    resize,
  }
}
